import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Restaurant = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="restaurant icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1.5C5 0.671573 4.32843 0 3.5 0C2.67157 0 2 0.671573 2 1.5V5.94444C2 8.462 3.69149 10.5845 6 11.2374L6 22.5C6 23.3284 6.67157 24 7.5 24C8.32843 24 9 23.3284 9 22.5L9 11.2374C11.3085 10.5845 13 8.462 13 5.94444V1.5C13 0.671573 12.3284 0 11.5 0C10.6716 0 10 0.671573 10 1.5V5.94444C10 6.76235 9.60722 7.48852 9 7.94463L9 1.5C9 0.671573 8.32843 0 7.5 0C6.67157 0 6 0.671573 6 1.5L6 7.94463C5.39278 7.48852 5 6.76235 5 5.94444V1.5ZM22 22.5C22 23.5 21.5 24 20.5 24C19.5 24 19 23.5 19 22.5V16H17.5C16.5 16 16 15.5 16 14.5538V6C16 3 18.5 3.23029e-06 20.5 3.23029e-06C21.5 3.23029e-06 22 0.5 22 1.5V22.5Z"
    />
  </svg>
)
